// extracted by mini-css-extract-plugin
module.exports = {"rule":"Rule_rule__EwA3A","title":"Rule_title__2mbDr","body":"Rule_body__OzTbY"};